import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

/**
 * Modal component that prompts the user about an active account and provides actions to proceed or cancel.
 * @component
 * @selector app-active-account-modal
 * @example
 *   <app-active-account-modal (onProceed)="handleProceed()" (onCancel)="handleCancel()"></app-active-account-modal>
 * @input None - This component does not accept any input properties.
 * @output EventEmitter<void> onProceed - Emitted when the user confirms or chooses to proceed. Triggered by the proceed() method.
 * @output EventEmitter<void> onCancel - Emitted when the user cancels or closes the modal. Triggered by the cancel() method.
 *
 * Key methods:
 * - proceed(): Emits the onProceed event to notify parent components that the user chose to proceed.
 * - cancel(): Emits the onCancel event to notify parent components that the user cancelled the action.
 *
 * Lifecycle hooks:
 * - This component does not implement any Angular lifecycle hooks (OnInit, OnDestroy, etc.) by default.
 */
@Component({
  selector: 'app-active-account-modal',
  templateUrl: './active-account-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./active-account-modal.component.scss'],
})
export class ActiveAccountModalComponent {
  @Output() proceeded = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();

  proceed() {
    this.proceeded.emit();
  }

  cancel() {
    this.cancelled.emit();
  }
}
